/**
 * Smatchy
 * The smatchy API description. Use POST /auth/login to get an access token.
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface PremiumRoleEntity { 
    id?: string;
    key: string;
    value: string;
    description?: string;
    isActive?: boolean;
    grantedAt?: string;
    insuranceExpirationDate?: string;
    adminDefinedRole?: string;
    createdAt?: string;
    updatedAt?: string;
    deletedAt?: string | null;
}

